// lib/noticeAcknowledgements.ts
import type { UserPreferences } from '#types/types';

export const acknowledgedNoticeIds = (preferences: UserPreferences): string[] => {
  const ids = Array.isArray(preferences.acknowledgedNoticeIds)
    ? preferences.acknowledgedNoticeIds.filter((id): id is string => typeof id === 'string' && id.length > 0)
    : [];
  // Existing release acknowledgements remain valid when upgrading older clients.
  const release = preferences.slidesWelcomeVersion;
  return [...new Set(typeof release === 'string' && release ? [...ids, `slides:${release}`] : ids)];
};
